import AudioPlayer from "./AudioPlayer";
import summaryCommonStore from "@/store/summaryCommon.store";
import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";
import avPlayerStore from "@/store/avPlayer.store";
import AVPlayerHelper from "@/bussiness/AVPlayerHelper";

const PlayerFooter = () => {

  useEffect(() => {
    const handleKeyDown = (event: { key: string; preventDefault: () => void; stopPropagation: () => void; }) => {
      if (summaryCommonStore.getState().imagePreviewerVisible) return;

      if (event.key === 'ArrowLeft') {
        console.log('音频快退');
        AVPlayerHelper.advOrBackAudio(-5);
      } else if (event.key === 'ArrowRight') {
        console.log('音频快进');
        AVPlayerHelper.advOrBackAudio(5);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    }
  })

  const { audioInfo, audioScTimeList } = summaryCommonStore(
    useShallow((state) => ({
      audioInfo: state.audioInfo,
      audioScTimeList: state.audioScTimeList,
    }))
  );

  const { videoLoadFailure } = summaryCommonStore(
    useShallow((state) => ({
      videoLoadFailure: state.videoLoadFailure
    }))
  );

  const { updatePlayingTime, setIsAudioPlaying } =
    avPlayerStore.getState();

  const onCurrentNumChange = (val: number) => {
    updatePlayingTime(val);
  };

  const onAudioInsLoaded = (audioIns: AudioPlayerIns) => {
    avPlayerStore.getState().setAudioPlayerIns(audioIns);
  };

  const onIsPlayingChange = (isPlaying: boolean) => {
    setIsAudioPlaying(isPlaying);
  };

  return (
    audioInfo?.audioSrc && <div className="w-full h-full flex flex-col justify-between max-h-17.5 bg-#fff">
      <div className="flex-1 w-full"></div>
      <AudioPlayer
        audioInfo={audioInfo}
        videoLoadFailure={videoLoadFailure}
        scTimeList={audioScTimeList}
        onIsPlayingChange={onIsPlayingChange}
        onCurrentNumChange={onCurrentNumChange}
        onAudioInsLoaded={onAudioInsLoaded}
      />
    </div>
  );
};

export default PlayerFooter;
